import { DEFAULT_LOCALE } from '@/shared/services/services-constants'

export default {
    locale: DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    silentFallbackWarn: true,
    silentTranslationWarn: process.env.NODE_ENV !== 'development',
    messages: { }
}
